var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import Select from "@atlaskit/select";
import { compose, graphql, Separator, TextField } from "@atlassiansox/microscopekit";
import minifiedServiceTemplatesQuery from "../../graphql/service-minified-templates.query.graphql";
import wargameEnvironmentsQuery from "../../graphql/wargame-environments.query.graphql";
import { lifecycle } from "recompose";
import SectionMessage from "@atlaskit/section-message";
import { LabelWithHelperText } from "../LabelWithHelperText";
import { useSendScreenEvent } from "../../analytics";
import { useSupportedEnvironments } from "../../hooks";
import { isEmpty } from "lodash";
import styled from "styled-components";
var FirstForm = function (props) {
    var _a = __read(useState(props.wargameTemplate.name ? props.wargameTemplate.name : ""), 2), name = _a[0], setName = _a[1];
    var _b = __read(useState(false), 2), isNameInputInvalid = _b[0], setNameInputInvalid = _b[1];
    var _c = useSupportedEnvironments(), isLoadingSupportedEnvironments = _c.isLoading, supportedEnvironments = _c.supportedEnvironments;
    var selectOptions = [];
    supportedEnvironments.forEach(function (key) {
        selectOptions = selectOptions.concat([
            {
                label: key,
                value: key
            }
        ]);
    });
    var hasValidDeployment = !isEmpty(selectOptions);
    var existingTemplateNames = props.minifiedServiceTemplatesData
        .warGameTemplateForService
        ? props.minifiedServiceTemplatesData.warGameTemplateForService.map(function (wargameTemplate) {
            return wargameTemplate.name ? wargameTemplate.name.trim().toLowerCase() : "";
        })
        : [];
    var _d = __read(useState(props.wargameTemplate.environment &&
        isValidEnvironment(props.wargameTemplate.environment, supportedEnvironments)
        ? {
            value: props.wargameTemplate.environment,
            label: props.wargameTemplate.environment
        }
        : undefined), 2), selectedOption = _d[0], setSelectedOption = _d[1];
    var isFormValid = function () {
        return (name.length > 0 &&
            !isNameInputInvalid &&
            selectedOption !== undefined &&
            hasValidDeployment);
    };
    useSendScreenEvent("createWargamePlanIntroductionStep");
    useEffect(function () {
        if (name.length > 0 && isValidName(name, existingTemplateNames)) {
            props.wargameTemplate.name = name;
        }
        if (selectedOption !== undefined) {
            props.wargameTemplate.environment = selectedOption.value;
        }
        props.setIsFormValid(isFormValid());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [name, selectedOption]);
    useEffect(function () {
        var _a, _b, _c;
        if (props.wargameTemplate !== undefined) {
            setName((_a = props.wargameTemplate.name) !== null && _a !== void 0 ? _a : "");
            if (props.wargameTemplate.environment &&
                isValidEnvironment(props.wargameTemplate.environment, supportedEnvironments)) {
                setSelectedOption({
                    label: (_b = props.wargameTemplate.environment) !== null && _b !== void 0 ? _b : "NA",
                    value: (_c = props.wargameTemplate.environment) !== null && _c !== void 0 ? _c : "NA"
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.wargameTemplate]);
    return (React.createElement("div", null,
        React.createElement(SectionMessageDiv, { hidden: hasValidDeployment || isLoadingSupportedEnvironments },
            React.createElement(SectionMessage, { appearance: "error" }, "You cannot create wargame plan for this service since it does not have an active deployment in any staging environments")),
        React.createElement(TextField, { name: "name", label: React.createElement(LabelWithHelperText, { helperText: "Name of the wargame plan", label: "Name" }), value: name, onChange: function (e) {
                setName(e.target.value);
                setNameInputInvalid(!isValidName(e.target.value, existingTemplateNames));
            }, isRequired: true, isInvalid: isNameInputInvalid }),
        React.createElement("div", { hidden: !isNameInputInvalid },
            React.createElement(SectionMessage, { appearance: "error" }, "Name already taken")),
        React.createElement(Separator, null),
        React.createElement("label", null,
            React.createElement(LabelWithHelperText, { helperText: "The Micros environment where your wargame experiment will be run", label: "Micros Environment", insideHeader: true }),
            React.createElement(Select, { name: "microsEnv", options: selectOptions, value: selectedOption, placeholder: "Choose", onChange: function (v) { return setSelectedOption(v); }, menuPortalTarget: document.body, menuPosition: "fixed", isLoading: isLoadingSupportedEnvironments, isDisabled: isLoadingSupportedEnvironments }))));
};
export var FirstFormFc = compose(graphql(minifiedServiceTemplatesQuery, {
    name: "minifiedServiceTemplatesData",
    options: function (props) { return ({
        query: minifiedServiceTemplatesQuery,
        variables: { serviceId: props.serviceId }
    }); }
}), graphql(wargameEnvironmentsQuery, {
    name: "wargameEnvironments",
    options: function (props) { return ({
        query: wargameEnvironmentsQuery,
        variables: { serviceId: props.serviceId }
    }); }
}), lifecycle({
    componentDidMount: function () {
        if (!this.props.minifiedServiceTemplatesData.loading) {
            this.props.minifiedServiceTemplatesData.refetch();
        }
    }
}))(FirstForm);
var isValidName = function (name, existingTemplateNames) {
    return existingTemplateNames.indexOf(name.toLowerCase().trim()) < 0;
};
var isValidEnvironment = function (env, supportedEnvironments) {
    return supportedEnvironments.find(function (value) { return value === env; });
};
var SectionMessageDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 20px;\n  margin-top: 20px;\n"], ["\n  margin-bottom: 20px;\n  margin-top: 20px;\n"])));
var templateObject_1;
